import type { LeaveScheduleType } from "@/shared/types";

export const LEAVE_SCHEDULE_TYPES: LeaveScheduleType[] = ["annual", "medical", "unpaid", "business_trip"];

export const LEAVE_SCHEDULE_TYPE_COLORS: Record<LeaveScheduleType, string> = {
  annual: "background-brand-subtle",
  medical: "background-negative-subtle",
  unpaid: "background-notice-subtle",
  business_trip: "background-info-subtle",
};
